<script setup>
import { ref, watch } from "vue";
import BaseFlightItineraryItem from "@/views/v2/sales/flight/items/group/BaseFlightItineraryItem.vue";
import { useAirContentStore } from "@/stores/v2/content/airContentStore";

const props = defineProps({
  tripAirItem: {},
  priceClasses: {
    default: null,
  },
  showUpsell: {},
});

const emits = defineEmits([]);
const airContentStore = useAirContentStore();
const tripAirItemRef = ref(null);
const airlineItemMapRef = ref(null);
const aircraftItemMapRef = ref(null);
const airportCityItemMapRef = ref(null);

watch(
  () => props.tripAirItem,
  (newValue) => {
    tripAirItemRef.value = newValue;
  },
  { deep: true, immediate: true }
);

watch(
  () => airContentStore.airlineItemMap,
  (newValue) => {
    airlineItemMapRef.value = newValue;
  },
  { immediate: true, deep: true }
);
watch(
  () => airContentStore.aircraftItemMap,
  (newValue) => {
    aircraftItemMapRef.value = newValue;
  },
  { immediate: true, deep: true }
);
watch(
  () => airContentStore.airportCityItemMap,
  (newValue) => {
    airportCityItemMapRef.value = newValue;
  },
  { immediate: true, deep: true }
);

//region 辅助函数
function findSpecificPriceClass(priceClassId) {
  if (!priceClassId || !props.priceClasses) return null;

  for (const priceClass of props.priceClasses) {
    if (priceClass.priceClassId === priceClassId) return priceClass;
  }
}

function upsell() {
  emits("openUpsell");
}

//endregion 辅助函数
</script>

<template>
  <div
    class="tour_booking_form_box reservation-review"
    v-if="
      tripAirItemRef &&
      tripAirItemRef.flightItems &&
      tripAirItemRef.flightItems.length > 0
    "
  >
    <h3 class="heading_theme">{{ $t("itinerary-info") }}</h3>
    <div class="itinerary-item">
      <div
        v-for="(flightItem, flightIndex) in tripAirItemRef.flightItems"
        :key="flightIndex"
      >
        <BaseFlightItineraryItem
          :flight-index="flightIndex"
          :flight-item="flightItem"
          :flight-num="tripAirItemRef.flightItems.length"
          :aircraft-item-map="aircraftItemMapRef"
          :airline-item-map="airlineItemMapRef"
          :airport-city-map="airportCityItemMapRef"
          :price-class="findSpecificPriceClass(flightItem.priceClassId)"
        />
        <hr
          v-if="flightIndex < tripAirItemRef.flightItems.length - 1"
          style="color: #0a0a0a"
        />
      </div>
      <a class="text-pointer cursor-point main_color" @click="upsell" v-if="showUpsell"
        >More fare options <i class="fa fa-angle-right mb-3 mg-l-8"></i
      ></a>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
